import React, { useEffect, useState } from "react";
import { Input } from "../../../Components/FormElements";
import { CustomSelectBox } from "../../../Components/DropDown";
import { PrimaryButton } from "../../../Components/Cta";
import { SuccessModal } from "../../../Components/Modals";
import { useNavigate } from "react-router-dom";

export default function Stage6({ setTitle, updateData, changePage }) {
  const navigate = useNavigate()
  const [addressSame, setAddressSame] = useState(true);
  const [otpModal, setOtpModal] = useState(false);

  // States for inputs
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");

  const [country, setCountry] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");

  // Error states
  const [countryError, setCountryError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [pincodeError, setPincodeError] = useState("");

  useEffect(() => {
    setTitle("Permanent Address");
  }, [setTitle]);

  // Validation
  const validateForm = () => {
    let valid = true;

    if (!address1) valid = false;

    if (!country) {
      setCountryError(true);
      valid = false;
    } else setCountryError(false);

    if (!stateVal) {
      setStateError(true);
      valid = false;
    } else setStateError(false);

    if (!city) {
      setCityError(true);
      valid = false;
    } else setCityError(false);

    if (!pincode) {
      setPincodeError("Pincode is required");
      valid = false;
    } else if (!/^\d{6}$/.test(pincode)) {
      setPincodeError("Enter a valid 6-digit pincode");
      valid = false;
    } else {
      setPincodeError("");
    }

    return valid;
  };

  // Example options (replace with API/data)
  const COUNTRY_OPTIONS = [
    { label: "India", value: "IN" },
    { label: "USA", value: "US" },
  ];
  const STATE_OPTIONS = [
    { label: "Tamil Nadu", value: "TN" },
    { label: "Karnataka", value: "KA" },
  ];
  const CITY_OPTIONS = [
    { label: "Chennai", value: "CH" },
    { label: "Bangalore", value: "BLR" },
  ];

  // Submission handler
  const _handleSubmit = () => {
    if (validateForm()) {
      // collect data
      const data = {
        address1,
        address2,
        country,
        state: stateVal,
        city,
        pincode,
      };
      setOtpModal(true);
      updateData((prev) => ({ ...prev, ...data }));
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
          <div className="d-flex flex-column row-gap-2">
            <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16">
              Permanent Address
            </h5>
            <p className="e-font-16 e-font-weight-400 e-text-granite-gray m-0">
              Add address details
            </p>
          </div>

          <Input
            require
            type="text"
            label="Address line 1"
            placeholder="Enter address"
            className="w-100"
            value={address1}
            handleChange={setAddress1}
          />

          <Input
            type="text"
            label="Address line 2"
            placeholder="Enter address"
            className="w-100"
            value={address2}
            handleChange={setAddress2}
          />

          <div className="row row-cols-2">
            <div className="col">
              <CustomSelectBox
                label="Country"
                placeholder="Select country"
                require
                type={4}
                options={COUNTRY_OPTIONS}
                value={country}
                selectChange={setCountry}
                error={countryError}
              />
            </div>
            <div className="col">
              <CustomSelectBox
                label="State"
                placeholder="Select state"
                require
                type={4}
                options={STATE_OPTIONS}
                value={stateVal}
                selectChange={setStateVal}
                error={stateError}
              />
            </div>
          </div>

          <div className="row row-cols-2">
            <div className="col">
              <CustomSelectBox
                label="City"
                placeholder="Select city"
                require
                type={4}
                options={CITY_OPTIONS}
                value={city}
                selectChange={setCity}
                error={cityError}
              />
            </div>
            <div className="col">
              <Input
                type="number"
                require
                label="Pincode"
                className="w-100"
                placeholder="Enter pincode"
                value={pincode}
                error={pincodeError}
                handleChange={setPincode}
                onBlur={validateForm}
              />
            </div>
          </div>
          <div className="d-flex flex-column  ">
            <h5 className="e-primary-font-poppins e-text-eerie-black e-font-weight-500 e-font-16">
              Correspondence address details
            </h5>
            <div className="d-flex column-gap-2 align-items-center">
              <input
                type="checkbox"
                className="e-nominee-input"
                checked={addressSame}
                onChange={() => setAddressSame((prev) => !prev)}
              />
              <p className=" e-font-16 e-primary-font-poppins e-font-weight-400 e-text-granite-gray m-0">
                Same as permanent address
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-10 offset-lg-2 col-12 pt-3">
          <div className="row">
            <div className="col-6">
              <PrimaryButton
                ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
                name="Go back"
                onPress={() => changePage(5)}
              />
            </div>
            <div className="col-6">
              <PrimaryButton
                ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                name="Continue"
                onPress={_handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
      {otpModal && (
        <SuccessModal
          title={"Account created"}
          message={
            "Your investment account has been successfully created and verified. you are now ready to start investing"
          }
          onClick={() => {setOtpModal(false)
            navigate('/customer')
          }}
          close={() => setOtpModal(false)}
          buttonName={"Go Back"}
        />
      )}
    </div>
  );
}
